import { useMemo } from "react";
import electronShader_frag from "./electrons_frag.glsl";
import electronShader_vert from "./electrons_vert.glsl";

import * as THREE from "three";
import { useFrame } from "@react-three/fiber";

const InductiveTransmissionAnimation = ({ radius = 1, ...props }) => {
  var [mat1, mat2] = useMemo(() => {
    // var mat = new MeshBasicMaterial({
    //   wireframe: true,
    //   color: 0xff0000,
    //   depthWrite: false,
    //   depthTest: false,
    //   transparent: true,
    // });

    var mat1 = new THREE.ShaderMaterial({
      fragmentShader: electronShader_frag,
      vertexShader: electronShader_vert,
      // vertexColors: true,
      transparent: true,
      depthWrite: false,
      depthTest: true,
      side: THREE.DoubleSide,
      // blending: AdditiveBlending,
      uniforms: {
        uTime: {
          value: 0,
        },
        uSpeed: {
          value: 17.5,
        },
        uBaseColor: {
          value: new THREE.Color("#ffa600"),
        },
        uBaseColorPower: {
          value: 3,
        },
        uSize: {
          value: 0.01,
        },
        uStep: {
          value: 0.9,
        },
        uStepRange: {
          value: 0.5,
        },
      },
    });

    const mat2 = mat1.clone();
    mat2.uniforms.uBaseColor.value = new THREE.Color("#68acfa");

    return [mat1, mat2];
  }, []);

  useFrame(({ clock }) => {
    mat1.uniforms.uTime.value = clock.elapsedTime;
    mat2.uniforms.uTime.value = clock.elapsedTime;
  });

  return (
    <group {...props}>
      <mesh rotation={[THREE.MathUtils.degToRad(90), 0, 0]} material={mat1} position={[0, -0.1, 0]}>
        <torusGeometry args={[radius, 0.05]} />
      </mesh>
      <mesh rotation={[THREE.MathUtils.degToRad(-90), 0, 0]} material={mat2} position={[0, 0.1, 0]}>
        <torusGeometry args={[radius, 0.05]} />
      </mesh>
    </group>
  );
};

export default InductiveTransmissionAnimation;
